angular
    .module("empower.home", [
        'home.controller',
        'home.service',
        'home.directive',
        'empower.control'
    ])
    .config(['$routeProvider', function ($routeProvider) {
        $routeProvider
            .when('/', {
                templateUrl: 'module/home/view/dashboard.html',
                controller: 'homeController'               
            })
            .when('/home', {
                templateUrl: 'module/home/view/dashboard.html',
                controller: 'homeController'
            })
            .when('/forgot-password', {
                templateUrl: 'module/home/view/password-popup-wrapper.html',
                controller: 'forgotPasswordController'
            })
            .when('/activation/:token', {
                templateUrl: 'module/home/view/activation-resetPassword.html',
                controller: 'resetPasswordController'
            })
            .when('/reset-password/:token', {
                templateUrl: 'module/home/view/activation-resetPassword.html',
                controller: 'resetPasswordController'
            })
            .when('/maintenance-page', {
                templateUrl: 'module/home/view/maintenance-page.html',
            })  
    }]);
